import { LOGIN, loginSuccess, loginFailed } from "../actions";
import { ofType } from "redux-observable";
import { switchMap, map, catchError } from "rxjs/operators";
import { from, of } from "rxjs";
import GolferApi from "../../../services/golfer-api";

export default (action$) =>
  action$.pipe(
    ofType(LOGIN),
    switchMap(({ payload }) => login(payload))
  );

const login = (payload) =>
  from(
    GolferApi.login(
      payload.password,
      payload.emailOrGhin,
      payload.remember_me,
      payload.turnstileToken,
      payload.validateTurnstile
    )
  )
    .pipe(map((response) => loginSuccess(response.data, payload)))
    .pipe(catchError((error) => of(loginFailed(error.response?.data))));
